<template>
  <div class="flexcontents">
    <div class="main-content">
      <div class="nav" v-if="!isBrand">
        <div class="bread-crumb" v-if="showTitle">
          <a :href="`/${lang}`" class="textsa">{{ $t("home") }}</a>
          <img
            class="rightIconsa"
            src="/images/newpcImg/rightIconsa.png"
            alt=""
          />
          <a class="blodjs" :href="path">{{ title }}</a>
          <!-- <img
            v-show="title1"
            class="rightIconsa"
            src="/images/newpcImg/rightIconsa.png"
            alt=""
          />
          <a class="blodjs">{{ title1 }}</a>
          <img
            v-show="title2"
            class="rightIconsa"
            src="/images/newpcImg/rightIconsa.png"
            alt=""
          />
          <a class="blodjs">{{ title2 }}</a> -->
        </div>
      </div>
      <div class="flexcs">
        <sidebar2
          v-if="showSelect"
          :select-list="selectList"
          :is-whale="isWhale"
          @sort-change="change"
          :title2="title2"
          :title1="title1"
          :title="title"
          :routeids="routeids"
          :get-list-params="getListParams"
        />
        <!-- 品牌页只显示商品 -->
        <div
          :class="['hot-content', { 'is-brand': isBrand }]"
          v-loading="goodsListLoading"
        >
          <div class="goods-list" v-if="goodsList.length">
            <single-goods
              :item="product"
              v-for="product in goodsList"
              :key="product.product_id"
            />
          </div>
          <div v-else class="nogoods-list">
            <img src="/images/newpcImg/nogoods.svg" class="nogoods" alt="" />
            <div class="notexts">暂无商品，看看别的吧~</div>
          </div>
          <!-- <not-data v-else v-loading="goodsListLoading" /> -->
        </div>
      </div>
      <span style="display: block; clear: both; height: 0; font-size: 0"></span>
      <div class="page" v-show="goodsList.length">
        <page :link="link" @page-change="pageChange" />
      </div>
    </div>
  </div>
</template>

<script>
import singleGoods from "./singleGoodsFour";
import sidebar2 from "./sidebar2";
import page from "./pagination";
import notData from "./notData.vue";
export default {
  name: "",
  components: {
    singleGoods,
    sidebar2,
    page,
    notData,
  },
  props: {
    goodsList: Array,
    selectList: [Object],
    link: Array,
    isWhale: Boolean,
    goodsListLoading: Number,
    title: String,
    title2: String,
    title1: String,
    showTitle: {
      type: Boolean,
      default: true,
    },
    showSelect: {
      type: Boolean,
      default: true,
    },
    initCategory: {
      type: Array,
      default: () => [],
    },
    isBrand: {
      type: Boolean,
      default: false,
    },
    routeids: {
      type: String,
      default: "",
    },
    getListParams: Object,
  },
  data() {
    return {};
  },
  computed: {
    lang() {
      return localStorage.getItem("localLang");
    },
    path() {
      return window.location.href;
    },
  },
  methods: {
    change(val) {
      this.$emit("sort-change", val);
    },
    pageChange(url) {
      console.log(url, "11111111");
      this.$emit("page-change", url);
    },
  },
};
</script>

<style scoped lang="scss">
.rightIconsa {
  width: 0.3846rem;
  height: 0.3846rem;
  margin: 0 0.3846rem;
}
.flexcs {
  display: flex;
  align-items: self-start;
}
.blodjs {
  font-size: 0.5385rem;
  font-weight: bold;
  color: #333;
}
.textsa {
  font-size: 0.5385rem;
  font-weight: 400;
  color: #333;
}
.flexcontents {
  display: flex;
  justify-content: center;
  width: 100vw;
}
.main-content {
  background: #f9f9f9;
  padding: 0.3846rem;
  width: 46.1538rem;
  .nav {
    .bread-crumb {
      display: flex;
      align-items: center;
      font-size: 0.5385rem;
      a {
        font-size: 0.5385rem;
      }
    }
  }
  /deep/ .el-loading-mask {
    // background: #f9f9f9;
    z-index: 10;
  }
  .is-brand {
    width: 100%;
  }
  .hot-content {
    display: flex;
    // min-height: 386px;
    box-sizing: border-box;
    flex: 1;
    .goods-list {
      flex: 1;
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      grid-column-gap: .7692rem;
      align-items: center;
      flex-wrap: wrap;
      // justify-content: space-between;
      flex-wrap: wrap;
      background: #fff;
      margin-left: 0.3077rem;
      padding: 0 .7692rem;
      box-sizing: border-box;
      // display: grid;
      // gap: 0.5385rem;
      // grid-template-columns: repeat(auto-fill, minmax(9.6154rem, 1fr));
    }
    .nogoods-list {
      min-height: 23.0769rem;
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      // justify-content: space-between;
      background: #fff;
      margin-left: 0.3077rem;
      padding: 0.3846rem 0.3077rem;
      box-sizing: border-box;
      .nogoods {
        width: 4.2308rem;
        height: 4.2308rem;
      }
      .notexts {
        font-size: .5385rem;
        font-weight: 400;
        color: #999;
        margin-top: 10px;
      }
    }
  }
}
.hot-content {
  // width: calc(100vw - 18.4615rem);
}
@media screen and (max-width: 1900px) {
  // .hot-content {
  //   width: calc(100vw - 18.1923rem);
  // }
}
</style>



// WEBPACK FOOTER //
// resources/js/components/goodsListHot.vue